import React, { CSSProperties, FunctionComponent } from 'react';

import JobPreview from 'src/components/JobPreview';
import useQueryJobById from 'src/components/RelatedOffers/useQueryJobById';
import useTrackOfferClick from 'src/tracking/useTrackOfferClick';
import createPath from 'src/utils/create-path';

export type LiveJobPreviewProps = {
  index?: number;
  jobId?: string;
  className?: string;
  style?: CSSProperties;
  loading?: boolean;
};

const LiveJobPreview: FunctionComponent<LiveJobPreviewProps> = (props) => {
  const { index = 0, jobId, className, style } = props;

  const { job, error, loading } = useQueryJobById(jobId);
  const { shortId, caption, city, postalCode, weeklyHours, salary } = job || {};

  const to = createPath({ caption, city, shortId, type: 'job-offer' });

  const trackOfferClick = useTrackOfferClick();
  const handleOnClick = () => trackOfferClick(job);

  return (
    <JobPreview
      data-testid="JobPreview"
      css={{ minWidth: 'auto' }}
      error={!!error}
      id={jobId}
      to={to}
      onClick={handleOnClick}
      loading={props.loading || loading}
      position={index + 1}
      caption={caption}
      city={city}
      postalCode={postalCode}
      weeklyHours={weeklyHours}
      salary={salary}
      className={className}
      style={style}
    />
  );
};

export default LiveJobPreview;
